<div class="c-progressbagProgress">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-progressbagProgress__container">
    <div
      class="c-progressbagProgress__background"
      theming
      themingGroup="progressivebag"
      themingAsset="progress-background"
      [themingOverride]="event()?.assets">
      <div class="c-progressbagProgress__info">
        <div
          class="c-progressbagProgress__icon"
          theming
          themingGroup="progressivebag"
          themingAsset="logo"
          [themingOverride]="event()?.assets"></div>
        <div class="c-progressbagProgress__text">
          <span class="text title">{{ 'home.live-ops.progressbag.modal-progress.title' | translate | uppercase }}</span>
          <span class="text subtitle">{{ 'home.live-ops.progressbag.modal-progress.subtitle' | translate }}</span>

          <div class="c-progressbagProgress__text__points">
            <span class="text points">+{{ progressbagProgressModalData.properties.points }}</span>
            <span
              class="type-icon-text"
              theming
              themingGroup="progressivebag"
              themingAsset="icon-points"
              [themingOverride]="event()?.assets"></span>
          </div>

          <slotcom-button
            class="c-button--pink"
            (safeClick)="openProgressbag()"
            audioType="functionality">
            {{ 'home.buttons.accumulate' | translate | uppercase }}
          </slotcom-button>
        </div>
      </div>
    </div>
  </div>
</div>
